import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerContent}>
          {/* Company Info */}
          <div className={styles.companyInfo}>
            <span className={styles.copyrightText}>
              © {currentYear} Appelt-Bonfire Store | Website made by
              <a
                href="https://github.com/tybie"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footerLink}
              >
                Ty Bierwagen
              </a>
              {'  |  '}
              <Link to="/" className={styles.footerLink}>
                Home
              </Link>
              {'  |  '}
              <Link to="/contact" className={styles.footerLink}>
                Contact
              </Link>
              {'  |  '}
              <Link to="/refund-policy" className={styles.footerLink}>
                Refund Policy
              </Link>
              {'  |  '}
              <Link to="/privacy-policy" className={styles.footerLink}>
                Privacy Policy
              </Link>
              {'  |  '}
              <Link to="/terms-of-service" className={styles.footerLink}>
                Terms of Service
              </Link>
              {'  |  '}
              <Link to="/shipping-policy" className={styles.footerLink}>
                Shipping Policy
              </Link>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
